import React, { memo } from 'react';
import { Note } from '../store/types';
import { keyLaneToX, trackLaneToX, timePosToY, trackHue, trackNames } from './lane';
import { EditContainer } from '../store/EditContainer';
import classNames from 'classnames';

interface Props {
  note: Note;
  trackSelected: boolean;
}

export const NoteComponent: React.FC<Props> = memo(props => {
  const { verticalZoom } = EditContainer.useContainer();

  return (
    <div className="NoteComponent"
      style={{
        left: props.note.isKey ? keyLaneToX(props.note.lane) : trackLaneToX(props.note.track),
        top: timePosToY(props.note.timePos, verticalZoom),
        backgroundColor: `hsl(${trackHue(props.note.track)}, ${props.trackSelected ? '100%, 60%' : '70%, 30%'})`,
      }}
    >
      <div className={classNames('text', props.trackSelected && 'selected')}>
        {trackNames[props.note.track]}
      </div>
    </div>
  );
});
